export enum Role {
  Reader = "reader",
  Owner = "owner",
}
